import React from "react";
import styles from "./toolTipText.scss";

export default function ToolTip(props) {
  let { toolTipText, onToolTipClick, speechBubbleRequired, speechBubblePosition } = props;
  speechBubblePosition = speechBubblePosition ? speechBubblePosition : "";

  let speechBubblePositionClass = speechBubblePosition.length > 0 ? styles[speechBubblePosition] : "";

  return (
    <div className={styles.information} onClick={onToolTipClick}>
      <i className="aeh-icon-outlined-info">
        {speechBubbleRequired && (
          <div className={`${styles.speechBubble} ${speechBubblePositionClass}`}>
            <div className={styles.me}>{toolTipText}</div>
          </div>
        )}
      </i>
    </div>
  );
}

ToolTip.defaultProps = {
  onToolTipClick: () => {},
  speechBubbleRequired: true,
  speechBubblePosition: "",
};
